"use client";

import { DocsAccountControls } from "@/providers/account-session";
import { DocsGuestRail } from "@/components/docs/guest-rail";
import {
  Sidebar,
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar";

function HomeSidebar() {
  return (
    <Sidebar
      collapsible="icon"
      variant="inset"
      className="overflow-hidden max-md:!w-12 [&>[data-sidebar=sidebar]]:flex-row"
      onMobileOpenAutoFocus={(event) => {
        event.preventDefault();
        (event.target as HTMLElement).focus({ preventScroll: true });
      }}
    >
      <DocsAccountControls>
        <DocsGuestRail />
      </DocsAccountControls>
    </Sidebar>
  );
}

export function LandingShell({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SidebarProvider
        className="h-svh overflow-hidden"
        style={
          {
            "--sidebar-width": "calc(var(--sidebar-width-icon) + 1px)",
          } as React.CSSProperties
        }
      >
        <HomeSidebar />
        <SidebarInset className="max-h-svh overflow-hidden md:!ml-2 md:max-h-[calc(100svh-theme(spacing.4))]">
          <div className="portal-home-surface lb-scrollbar-overlay min-h-0 flex-1 overflow-y-auto">
            {children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
}
